const SUBSCRIPTION_ACTION_TYPES = {
  SET_SUBSCRIPTION: 'subscription/SET_SUBSCRIPTION',
  SET_SUBSCRIPTION_DATA: 'subscription/SET_SUBSCRIPTION_DATA',
  SET_SUBSCRIPTION_BUNDLE: 'subscription/SET_SUBSCRIPTION_BUNDLE',
  SET_SUBSCRIPTION_FREQUENCY: 'subscription/SET_SUBSCRIPTION_FREQUENCY',
  SET_SUBSCRIPTION_VARIANTS: 'subscription/SET_SUBSCRIPTION_VARIANTS',
  SET_SUBSCRIPTION_PATTERNS: 'subscription/SET_SUBSCRIPTION_PATTERNS',
  SET_SUBSCRIPTION_UPSELLS: 'subscription/SET_SUBSCRIPTION_UPSELLS',
  SET_SUBSCRIPTION_MIX: 'subscription/SET_SUBSCRIPTION_MIX',
  SET_SUBSCRIPTION_NAVIGATION: 'subscription/SET_SUBSCRIPTION_NAVIGATION',
  SET_SUBSCRIPTION_STEP: 'subscription/SET_SUBSCRIPTION_STEP',
  SET_SUBSCRIPTION_SIZE_SUBSTEPS: 'subscription/SET_SUBSCRIPTION_SIZE_SUBSTEPS',
  SET_SUBSCRIPTION_PATTERN_SUBSTEPS:
    'subscription/SET_SUBSCRIPTION_PATTERN_SUBSTEPS',
  GO_TO_BUNDLE: 'subscription/GO_TO_BUNDLE',
  GO_TO_SIZE: 'subscription/GO_TO_SIZE'
}

export default SUBSCRIPTION_ACTION_TYPES
